'use strict'

import PropTypes from 'prop-types'

import React from 'react'
import classnames from 'classnames'
import _ from 'underscore'
import {Cell as CellComponent} from 'fixed-data-table'

import './Cell.less'

const COMPONENT_CLASS = 'nmc-table-cell'

const CENTERED_CLASS = 'centered'

class Cell extends React.Component {
  /**
   * Get classes from by style property
   * @returns {String}
   */
  getStyleClasses () {
    return classnames({
      [CENTERED_CLASS]: this.props.style.centered
    })
  }

  render () {
    const classes = classnames(COMPONENT_CLASS, this.getStyleClasses(), this.props.columnClassName, {
      'nmc-table-cell-clickable': this.props.clickable
    })
    const props = _.omit(this.props, ['row', 'style', 'columnClassName', 'clickable'])
    return (
      <CellComponent className={classes} {...props}>
        {String(this.props.children)}
      </CellComponent>
    )
  }
}

Cell.propTypes = {
  row: PropTypes.object,
  style: PropTypes.object,
  clickable: PropTypes.bool,
  columnClassName: PropTypes.any
}

Cell.defaultProps = {
  style: {},
  columnClassName: '',
  clickable: false
}

export default Cell



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Table/Cell/index.js